import styled from 'styled-components'
import { themeFontWeight } from '@elparking/components'

const gray = props => props.theme.colors.gray || 'gray'
const cardBorder = props => props.isMarked ? `2px solid ${props.theme.colors.main}` : `1px solid ${props.theme.colors.gray20}`
const cardPadding = props => props.isMarked ? `15px` : `16px`
const mediaScreenMobile = props => `@media screen and (max-width: ${props.theme.screens.medium})`
const backgroundCard = ({isSelected, theme}) => isSelected ? `${theme.colors.main20}` : `${theme.colors.white}`

export const ChargingPointAddressBlock = styled.div`
    color: ${gray};
    white-space: normal;
    font-size: 12px;
    width: 100%;
    font-weight: ${themeFontWeight('regular')};
    line-height: 18px;

    ${mediaScreenMobile} {
        line-height: 22px;
        font-size: 14px;
    }
`

export const ChargingPointTextBlock = styled.div`
    float: right;
    width: 100%;
    font-size: 20px;
    font-weight: 400;
    font-size: 24px;
    line-height: 30px;
    position: relative;
`

export const Card = styled.div`
    padding: ${cardPadding};
    width: 100%;
    max-width:100%;
    color: ${gray};
    position: relative;
    background-color: ${backgroundCard};
    border: ${cardBorder};
    border-radius: 2px;
`

export const CardContainer = styled.div`
    display: flex;
`

export const PlugsContainer = styled.div`
    width: 100%;
    display: inline-block;
    ${mediaScreenMobile} {
        width: 100%;
    }
`

export const DistanceRightBlock = styled.div`
    font-size: 12px;
    font-weight: ${themeFontWeight('book')};
    line-height: 14px;
    display: inline-block;
    color: ${gray};
    margin-left: 8px;
    &:before {
        content: '·';
        margin-right: 8px;
    }
    ${mediaScreenMobile} {
        &:before {
            display: none;
        }
    }
 `

export const ChargingPointTextBlockHeader = styled.div`
    width: 100%;
`
